import axios from "axios";

const token = localStorage.getItem("wow-delivery-kw-merchant-token");

const DELETE = async (endpoint) => {
  const response = await axios.delete(endpoint, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export default DELETE;
